import type z from 'zod';
import type { AiSummarySchema } from './contracts';

export enum ComparisonModes {
  INTERNAL = 'INTERNAL',
  COMP = 'COMP',
}

export type AiSummary = z.infer<typeof AiSummarySchema>;
